module.exports = __webpack_public_path__ + "img/Grip@2x.31a2351a.png";